import { Poppins, Quicksand } from 'next/font/google'
import Image from 'next/image'
import React, { useState } from 'react'

const popins =Poppins({weight:"500",subsets:['latin']})
const quickSand =Quicksand({weight:"400",subsets:['latin']})
export default function Syllabus({CurriculumData,title}) {
    const [activeIndex, setActiveIndex] = useState(null);
    // Initialize arrowRotation with an array of false values
  const [arrowRotation, setArrowRotation] = useState(new Array(CurriculumData.length).fill(false));
  const handleAccordionClick = (index) => {
  setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  setArrowRotation((prevRotation) =>
  prevRotation.map((rotated, i) => (i === index ? !rotated : rotated))
  );
  };
 
  return (
   <>
   <section id='S2'>
    <div className='container'>
       <div className='mt40 df fdc fac'>
        <h2 className={`fs-40 ylw-clr mfs-22 ${popins.className} `}>{title} Course Curriculum</h2>

        {CurriculumData.map((items, index) => (
            <div key={index} className=''>
    <div className='accord-box mt16 cursor' onClick={() => handleAccordionClick(index)}>
       <div className='df fac fjsb '>
         <h3 className={`fs-19 mfs-15 ${popins.className}`}>{items.title}</h3>
         <div className={`${arrowRotation[index] ? 'rotate-arrow' : ''} fac`}  onClick={(e) => {
                            e.stopPropagation();
                            handleAccordionClick(index);
                            }}>
            <Image src={"/course-img/arrow-icon.webp"} alt='Arrow-Icon' width={"34"} height={"34"} loading='lazy'/>
         </div>
       </div>
       {index === activeIndex && (
                <ul>
                <p className='line-code'></p>
                {items.content.map((content, itemIndex) => 
                    (
                        <div key={index}>
                    <div className='df mt16'>
                    <i className="fas fa-circle circle-set "></i>
                    <li className={`dim-clr fs-16 mfs-13 df ${quickSand.className}`} key={itemIndex}>{content}</li>
                    </div> 
                    </div>))}
                </ul> 
            )}


    </div>

       </div> ))}
    </div>
    </div>
   </section>
   
   <style jsx>
    {`
     .circle-set{
        font-size:9px;
        display:flex;
        align-items: center;
        padding-right:10px;
        color: #FFA900;
    }
    .line-code{
        width:656px;
        margin: 24px 0px 24px 0px;
        border: 1.5px solid;
        background: linear-gradient(270deg, #FFFFFF -12.37%, #FFA900 53.79%, rgba(255, 255, 255, 0) 113.84%);
        border-image-slice: 1;
        border-image-width: 1.5px;
        border-image-outset: 0;

    border-image-source: linear-gradient(270deg, #FFFFFF -12.37%, #FFA900 53.79%, rgba(255, 255, 255, 0) 113.84%);
    }
    
        .accord-box{
            width: 720px;
            border-radius: 40px;
            padding: 32px;
            border: 0.5px solid #FFA900;
            box-shadow: 0px 4px 16px 0px #FFA90040;
    
        } 
        .rotate-arrow {
            transform: rotate(180deg);
            transition: transform 0.3s ease;
        }
        @media only screen and (max-width: 352px){
            .accord-box {
                width: 268px;
                padding: 15px;
                border-radius: 20px;
                border: 0.5px solid #ffa900;
                background-color: #ffffff;
                box-shadow: 0px 1px 4px 0px #ffa90040;
            }
            .line-code{
                width:100%;
                margin: 24px 0px 24px 0px;
                border: 1.5px solid;
                background: linear-gradient(270deg, #FFFFFF -12.37%, #FFA900 53.79%, rgba(255, 255, 255, 0) 113.84%);
                border-image-slice: 1;
                border-image-width: 1.5px;
                border-image-outset: 0;
            border-image-source: linear-gradient(270deg, #FFFFFF -12.37%, #FFA900 53.79%, rgba(255, 255, 255, 0) 113.84%);
            }
        }
        @media only screen and (min-width: 353px) and (max-width: 1023px){
            .accord-box {
                width: 325px;
                padding: 15px;
                border-radius: 20px;
                border: 0.5px solid #ffa900;
                background-color: #ffffff;
                box-shadow: 0px 1px 4px 0px #ffa90040;
            }
            .line-code{
                width:100%;
                margin: 24px 0px 24px 0px;
                border: 1.5px solid;
                background: linear-gradient(270deg, #FFFFFF -12.37%, #FFA900 53.79%, rgba(255, 255, 255, 0) 113.84%);
                border-image-slice: 1;
                border-image-width: 1.5px;
                border-image-outset: 0;
            border-image-source: linear-gradient(270deg, #FFFFFF -12.37%, #FFA900 53.79%, rgba(255, 255, 255, 0) 113.84%);
            }
        }
    

    
    `}
   </style>
   
   </>

  )
}
